//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import { Container, Row, Col } from 'react-bootstrap';
import BackToTopButton from '../BackToTopButton/BackToTopButton';
//  Config
import './docs.css';
//  ----------      END   IMPORT  BLOCK       ----------

function DocsLayout({ leftSidebar, content, rightSidebar }) {
  return (
    <Container fluid>
      <Row className="flex-nowrap"> {/* flex-nowrap prevents columns from jumping around */}
        {/* Left Sidebar */}
        <Col md={2} className="docs-sidebar d-none d-md-block px-3">
          {leftSidebar}
        </Col>

        {/* Main Content - This column will grow as long as needed */}
        <Col md={8} className="docs-content px-5">
          {content}
        </Col>

        {/* Right Nav */}
        <Col md={2} className="docs-nav d-none d-md-block px-3">
          {rightSidebar}
        </Col>
      </Row>
      <BackToTopButton />
    </Container>
  );
}

export default DocsLayout;
